import React, { useState, useEffect, useRef } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import CallIcon from "@material-ui/icons/Call";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import "../MapContainer.css";

import { mapKey } from "../constants/Config";

const LocationCard = React.lazy(() => import("./LocationCard"));

const MapContainer = ({ mapData, getLocation }) => {
  const [selected, setSelected] = useState({});
  const [currentPosition, setCurrentPosition] = useState({});
  const mapRef = useRef(null);

  const defaultCenter = {
    lat: 33.448376,
    lng: -112.074036,
  };

  const onSelect = (item) => setSelected(item);

  const success = (position) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setCurrentPosition({ lat: latitude, lng: longitude });
  };

  const mapStyles = {
    marginTop: "10px",
    height: "80vh",
    width: "80%",
  };

  useEffect(() => {
    if (mapData && mapData.currentPosition) {
      setCurrentPosition(mapData.currentPosition);
    } else {
      navigator.geolocation.getCurrentPosition(success);
    }
  }, [mapData]);

  useEffect(() => {
    if (
      mapRef.current &&
      mapData?.agencyList?.length > 0
    ) {
      const bounds = new window.google.maps.LatLngBounds();

      mapData.agencyList.forEach((location) => {
        bounds.extend({ lat: location.latitude, lng: location.longitude });
      });

      if (currentPosition.lat && currentPosition.lng) {
        bounds.extend(currentPosition);
      }

      if (!bounds.isEmpty()) {
        setTimeout(() => {
          mapRef.current.fitBounds(bounds);
        }, 600);
      }
    }
  }, [mapData.agencyList, currentPosition]);


  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LoadScript
        id="script-loader"
        googleMapsApiKey={mapKey}
      >
        <div
          style={{
            display: "flex",
            placeContent: "center",
            padding: "0 10em 0 10em",
          }}
        >
          <GoogleMap
            id="script-loader"
            mapContainerStyle={mapStyles}
            onLoad={(map) => {
              mapRef.current = map;
            }}
            zoom={11}
            center={currentPosition.lat ? currentPosition : defaultCenter}
          >
            {mapData.agencyList.length > 0 &&
              mapData.agencyList.map((item) => (
                <Marker
                  key={item.Id}
                  position={{ lat: item.latitude, lng: item.longitude }}
                  onClick={() => onSelect(item)}
                />
              ))}

            {selected.name && (
              <InfoWindow
                position={{ lat: selected.latitude, lng: selected.longitude }}
                onCloseClick={() => setSelected({})}
              >
                <div
                  className="infowindow"
                  style={{
                    border: "none",
                    marginRight: "5px",
                    backgroundColor: "#0d3693",
                  }}
                >
                  <p
                    style={{
                      borderBottom: "1px solid white",
                      width: "100%",
                      paddingBottom: "17px",
                      marginBottom: 0,
                      color: "white",
                    }}
                  >
                    <b style={{ fontSize: "15px" }}>{selected.name}</b>
                  </p>
                  <p
                    style={{
                      fontWeight: 500,
                      marginBottom: 0,
                      color: "white",
                    }}
                  >
                    <LocationCityIcon
                      style={{
                        marginRight: "5px",
                        verticalAlign: "middle",
                      }}
                    >
                      Location Icon
                    </LocationCityIcon>
                    {selected.formattedAddress}
                  </p>
                  <p style={{ fontWeight: 500, color: "white" }}>
                    <CallIcon
                      style={{ marginRight: "5px", verticalAlign: "middle" }}
                    >
                      Phone Icon
                    </CallIcon>
                    {selected.phone}
                  </p>
                </div>
              </InfoWindow>
            )}
          </GoogleMap>
          {mapData.agencyList.length > 0 && (
            <div
              style={{
                height: "47.5em",
                overflowY: "scroll",
                width: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                }}
              >
                {mapData.agencyList.map((item) => (
                  <LocationCard
                    key={item.Id}
                    location={item}
                    onSelect={onSelect}
                    selected={selected}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </LoadScript>
    </React.Suspense>
  );
};

export default MapContainer;
